"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _default = {
  PropTypes: {
    children: _propTypes.default.node.isRequired,
    departStation: _propTypes.default.string.isRequired,
    arrivalStation: _propTypes.default.string.isRequired,
    endDate: _propTypes.default.string,
    currency: _propTypes.default.string,
    airlineProfile: _propTypes.default.string,
    date: _propTypes.default.string,
    range: _propTypes.default.string,
    beginDate: _propTypes.default.string,
    isDestinationCity: _propTypes.default.string,
    isOriginCity: _propTypes.default.string,
    environment: _propTypes.default.string,
    channelHash: _propTypes.default.string,
    userType: _propTypes.default.string,
    authToken: _propTypes.default.string,
    domain: _propTypes.default.string
  },
  DefaultProps: {
    environment: 'staging',
    domain: 'com'
  }
};
exports.default = _default;